import React from "react";
// Material Imports
import { styled } from "@mui/material/styles";
// Modern
import Switch from "@limitless/modern/inputs/switch/Switch";
// Limitless Icons
import { SUN_PATH } from "@limitless/icons/Sun";
import { MOON_PATH } from "@limitless/icons/Moon";
const DMSwitch = styled(Switch)(({
  theme
}) => ({
  "& .MuiSwitch-track": {
    backgroundColor: `${theme.palette.primary.main} !important`,
    opacity: "1 !important",
    "&:before, &:after": {
      // eslint-disable-next-line quotes
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16
    },
    "&:before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(theme.palette.getContrastText(theme.palette.primary.main))}" d="${SUN_PATH}"/></svg>')`,
      left: 4
    },
    "&:after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(theme.palette.getContrastText(theme.palette.primary.main))}" d="${MOON_PATH}" /></svg>')`,
      right: 4
    }
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 20,
    height: 20
  }
}));
const DarkModeSwitch = ({
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(DMSwitch, rest);
};
DarkModeSwitch.propTypes = {};
export default DarkModeSwitch;